export const surfacesEn = {
  'moderation.reviewSaved': 'Review details saved.',
  'moderation.reviewSaveFailed': 'Could not save the review.',
  'moderation.reasonRequired': 'Add a reason before taking an action.',
  'moderation.confirmTitle': '{action} this target?',
  'moderation.confirmBody': 'This creates a permanent audit entry. Verify the target and reason before continuing.',
  'moderation.confirmAction': 'Confirm action',
  'moderation.actionRecorded': 'Moderation action recorded.',
  'moderation.actionFailed': 'Could not apply the action.',
  'moderation.appealPrompt': 'Explain this appeal decision to the appellant:',
  'moderation.appealRecorded': 'Appeal decision recorded.',
  'moderation.appealFailed': 'Could not resolve the appeal.',
  'moderation.staffOnly': 'Staff only',
  'moderation.title': 'Content moderation',
  'moderation.intro': 'Review reports consistently. Reporter identities and internal notes are only visible to authorized moderators.',
  'moderation.queue': 'Report queue',
  'moderation.status': 'Status',
  'moderation.open': 'Open',
  'moderation.resolved': 'Resolved',
  'moderation.dismissed': 'Dismissed',
  'moderation.all': 'All',
  'moderation.target': 'Target',
  'moderation.loadingReports': 'Loading reports',
  'moderation.noReports': 'No reports match these filters.',
  'moderation.created': 'Created',
  'moderation.reason': 'Reason',
  'moderation.priority': 'Priority',
  'moderation.review': 'Review',
  'moderation.noDetails': 'No reporter details supplied.',
  'moderation.reviewTarget': 'Review {target} report',
  'moderation.closeReview': 'Close review',
  'moderation.evidence': 'Evidence snapshot',
  'moderation.assignTo': 'Assign to',
  'moderation.unassigned': 'Unassigned',
  'moderation.internalNotes': 'Internal notes',
  'moderation.saveAssignment': 'Save assignment and notes',
  'moderation.action': 'Moderation action',
  'moderation.reasonCode': 'Reason code',
  'moderation.requiredRationale': 'Required decision rationale',
  'moderation.reviewConfirm': 'Review and confirm action',
  'moderation.pendingAppeals': 'Pending appeals',
  'moderation.noAppeals': 'No pending appeals.',
  'moderation.overturn': 'Overturn',
  'moderation.uphold': 'Uphold',
  'venue.application.proofError': 'Could not process this image. Please try a JPEG, PNG, HEIC, or PDF file.',
  'venue.application.submitted': 'Venue application submitted for review.',
  'venue.application.submitError': 'Could not submit your application. Please try again.',
  'venue.application.eyebrow': 'Business verification',
  'venue.application.title': 'Become a verified business',
  'venue.application.intro': 'Verified professional hosts get a trusted badge, business discovery, team access, and recurring-event tools.',
  'venue.application.status.pending': 'Pending',
  'venue.application.status.approved': 'Approved',
  'venue.application.status.rejected': 'Rejected',
  'venue.application.pendingHelp': 'Staff are reviewing your business details and proof.',
  'venue.application.name': 'Business or organization name',
  'venue.application.location': 'Fixed location (optional where not applicable)',
  'venue.application.website': 'Website or menu',
  'venue.application.phone': 'Public phone',
  'venue.application.proof': 'Proof of address or business ownership',
  'venue.application.converting': 'Converting image…',
  'venue.application.proofHelp': 'JPEG, PNG, HEIC, or PDF. Visible only to venue reviewers.',
  'venue.application.submitting': 'Submitting…',
  'venue.application.submit': 'Submit application',
  'venue.dashboard.nav.workspace': 'Workspace',
  'venue.dashboard.nav.overview': 'Overview',
  'venue.dashboard.nav.overviewHelp': 'At-a-glance business activity',
  'venue.dashboard.backToSettings': 'Back to business settings',
  'venue.dashboard.nav.operations': 'Operations',
  'venue.dashboard.nav.operationsHelp': 'Bookings and operational work',
  'venue.dashboard.nav.events': 'Events',
  'venue.dashboard.nav.eventsHelp': 'Your public programme',
  'venue.dashboard.nav.resources': 'Resources',
  'venue.dashboard.nav.resourcesHelp': 'Bookable catalogue and page',
  'venue.dashboard.nav.community': 'Community',
  'venue.dashboard.nav.communityHelp': 'Posts, directory and chat',
  'venue.dashboard.nav.inbox': 'Inbox',
  'venue.dashboard.nav.inboxHelp': 'Shared customer messages',
  'venue.dashboard.nav.business': 'Business',
  'venue.dashboard.nav.profile': 'Profile',
  'venue.dashboard.nav.profileHelp': 'Public business details',
  'venue.dashboard.nav.team': 'Team',
  'venue.dashboard.nav.teamHelp': 'Access and audit trail',
  'venue.dashboard.nav.notifications': 'Notifications',
  'venue.dashboard.nav.notificationsHelp': 'Organizer and delivery defaults',
  'venue.dashboard.nav.performance': 'Performance',
  'venue.dashboard.nav.insights': 'Insights',
  'venue.dashboard.nav.insightsHelp': 'Aggregate event performance',
  'venue.dashboard.nav.finance': 'Finance',
  'venue.dashboard.nav.financeHelp': 'Payments and subscription',
  'venue.dashboard.nav.preferences': 'Preferences',
  'venue.dashboard.nav.preferencesHelp': 'Business language',
  'venue.dashboard.nav.account': 'Access & security',
  'venue.dashboard.nav.accountHelp': 'Login and session access',
  'venue.dashboard.nav.data': 'Business data',
  'venue.dashboard.nav.dataHelp': 'Export and business closure',
  'venue.dashboard.system': 'System',
  'venue.dashboard.profileSaved': 'Business profile saved.',
  'venue.dashboard.profileSaveFailed': 'Could not save the venue profile.',
  'venue.dashboard.notificationsSaved': 'Business notification preferences saved.',
  'venue.dashboard.notificationsSaveFailed': 'Could not save notification preferences.',
  'venue.dashboard.languageSaveFailed': 'Could not save the business language.',
  'venue.dashboard.emailRequested': 'Check the new email address to confirm the change.',
  'venue.dashboard.emailRequestFailed': 'Could not request the email change.',
  'venue.dashboard.passwordInvalid': 'Passwords must match and contain at least 8 characters.',
  'venue.dashboard.passwordChanged': 'Password changed.',
  'venue.dashboard.passwordChangeFailed': 'Could not change the password.',
  'venue.dashboard.exportDownloaded': 'Business data export downloaded.',
  'venue.dashboard.exportFailed': 'Could not export business data.',
  'venue.dashboard.closureConfirmTitle': 'Schedule business closure?',
  'venue.dashboard.closureConfirmBody':
    'The business account and owned content will be permanently deleted after the 7-day grace period. Staff accounts are not deleted.',
  'venue.dashboard.scheduleClosure': 'Schedule closure',
  'venue.dashboard.keepBusiness': 'Keep business',
  'venue.dashboard.closureScheduled': 'Business closure scheduled.',
  'venue.dashboard.closureFailed': 'Could not schedule business closure.',
  'venue.dashboard.invitationCreated': 'Team invitation created.',
  'venue.dashboard.invitationFailed': 'Could not invite this user.',
  'venue.dashboard.invitationAccepted': 'Venue invitation accepted.',
  'venue.dashboard.invitationDeclined': 'Venue invitation declined.',
  'venue.dashboard.invitationUpdateFailed': 'Could not update this invitation.',
  'venue.dashboard.transferTitle': 'Transfer venue ownership?',
  'venue.dashboard.transferBody': 'The new owner will receive full control of the venue and its team.',
  'venue.dashboard.transfer': 'Transfer ownership',
  'venue.dashboard.transferSuccess': 'Ownership transferred.',
  'venue.dashboard.roleUpdated': 'Team role updated.',
  'venue.dashboard.roleUpdateFailed': 'Could not update this role.',
  'venue.dashboard.removeTitle': 'Remove team member?',
  'venue.dashboard.removeBody': 'They will immediately lose access to this venue dashboard.',
  'venue.dashboard.remove': 'Remove',
  'venue.dashboard.memberRemoved': 'Team member removed.',
  'venue.dashboard.memberRemoveFailed': 'Could not remove this team member.',
  'venue.dashboard.event': 'Event',
  'venue.dashboard.date': 'Date',
  'venue.dashboard.waitlisted': 'Waitlisted',
  'venue.dashboard.noShows': 'No-shows',
  'venue.dashboard.repeatParticipants': 'Repeat participants',
  'venue.dashboard.feedback': 'Feedback',
  'venue.dashboard.title': 'Business dashboard',
  'venue.dashboard.sectionIntro': '{section} for your public presence, programming, and team.',
  'venue.dashboard.invitedAs': 'You were invited to join a business as {role}.',
  'venue.dashboard.accept': 'Accept',
  'venue.dashboard.decline': 'Decline',
  'venue.dashboard.restricted': 'This dashboard is available to verified businesses and accepted business staff.',
  'venue.dashboard.businessApplication': 'Business application',
  'venue.dashboard.shortcutsAria': 'Business dashboard shortcuts',
  'venue.dashboard.sectionsAria': 'Business dashboard sections',
  'venue.dashboard.upcomingEvents': 'Upcoming events',
  'venue.dashboard.publicProgramme': 'Public programme ahead',
  'venue.dashboard.teamMembers': 'Team members',
  'venue.dashboard.acceptedStaff': 'Accepted business staff',
  'venue.dashboard.measuredEvents': 'Across measured events',
  'venue.dashboard.publicProfile': 'Public profile',
  'venue.dashboard.business': 'Business',
  'venue.dashboard.addAddress': 'Add an address',
  'venue.dashboard.quickActions': 'Quick actions',
  'venue.dashboard.createEvent': 'Create event',
  'venue.dashboard.openOperations': 'Open operations',
  'venue.dashboard.manageResources': 'Manage resources',
  'venue.dashboard.editProfile': 'Edit profile',
  'venue.dashboard.eventsHelp': 'Create one-off events or use the repeat controls for recurring programming.',
  'venue.dashboard.eventsLoadFailed': 'Business events could not be loaded. Please try again.',
  'venue.dashboard.noEvents': 'No business events yet.',
  'venue.dashboard.starts': 'Starts',
  'venue.dashboard.responses': 'Responses',
  'venue.dashboard.going': 'No one going | {count} going | {count} going',
  'venue.dashboard.open': 'Open',
  'venue.dashboard.profileHelp': 'Verification is controlled by administrators. Business staff can update the public details below.',
  'venue.dashboard.newProfileImage': 'New business profile image',
  'venue.dashboard.currentProfileImage': '{name} current profile image',
  'venue.dashboard.logo': 'Logo or profile image',
  'venue.dashboard.businessName': 'Business name',
  'venue.dashboard.publicHandle': 'Public handle',
  'venue.dashboard.businessIntro': 'Business introduction',
  'venue.dashboard.publicAddress': 'Public address',
  'venue.dashboard.website': 'Website',
  'venue.dashboard.phone': 'Phone',
  'venue.dashboard.accessibility': 'Accessibility information',
  'venue.dashboard.accessibilityPlaceholder': 'Step-free access, accessible toilets, hearing loop…',
  'venue.dashboard.mapLocation': 'Map location',
  'venue.dashboard.mapLocationHelp': 'A map location is currently set. Search below only if you want to replace it.',
  'venue.dashboard.addPhotos': 'Add business photos',
  'venue.dashboard.photoAlt': 'Business photo {number}',
  'venue.dashboard.photoAltLabel': 'Photo {number} alternative text',
  'venue.dashboard.describePhoto': 'Describe this photo',
  'venue.dashboard.saving': 'Saving…',
  'venue.dashboard.saveProfile': 'Save public profile',
  'venue.dashboard.editorProfileRestriction': 'Editors can manage programming but cannot change the public profile.',
  'venue.dashboard.insightsTitle': 'Privacy-preserving insights',
  'venue.dashboard.exportCsv': 'Export aggregate CSV',
  'venue.dashboard.insightsPrivacy':
    'Anonymous impressions are deduplicated daily. Feedback is suppressed below five responses; individual browsing histories are never stored or shown.',
  'venue.dashboard.noInsights': 'Insights will appear as your events receive responses.',
  'venue.dashboard.discovery': 'Discovery',
  'venue.dashboard.waitlist': 'Waitlist',
  'venue.dashboard.repeat': 'Repeat',
  'venue.dashboard.noShowCount': 'No no-shows | {count} no-show | {count} no-shows',
  'venue.dashboard.suppressed': 'Suppressed',
  'venue.dashboard.businessTeam': 'Business team',
  'venue.dashboard.teamHelp': 'Owners have full control; managers manage the profile and team; editors manage programming only.',
  'venue.dashboard.userId': 'User account ID',
  'venue.dashboard.userIdPlaceholder': 'PocketBase user ID',
  'venue.dashboard.role': 'Role',
  'venue.dashboard.editor': 'Editor',
  'venue.dashboard.manager': 'Manager',
  'venue.dashboard.invite': 'Invite',
  'venue.dashboard.you': 'you',
  'venue.dashboard.owner': 'Owner',
  'venue.dashboard.removeMemberAria': 'Remove team member',
  'venue.dashboard.auditTrail': 'Audit trail',
  'venue.dashboard.auditHelp': 'Sensitive profile, team, and ownership changes are retained for accountability.',
  'venue.dashboard.noAudit': 'No audit entries yet.',
  'venue.dashboard.businessNotifications': 'Business notifications',
  'venue.dashboard.notificationsHelp':
    'Configure messages sent to the business identity. Staff members control delivery to their own accounts from personal settings.',
  'venue.dashboard.organizedEvents': 'Events you organize',
  'venue.dashboard.remindAttendees': 'Remind attendees before events',
  'venue.dashboard.reminderLead': 'Default reminder lead time (hours)',
  'venue.dashboard.webPush': 'Web push',
  'venue.dashboard.email': 'Email',
  'venue.dashboard.importantChanges': 'Important event changes',
  'venue.dashboard.upcomingReminders': 'Upcoming event reminders',
  'venue.dashboard.discussionMentions': 'Event discussion and mentions',
  'venue.dashboard.saveNotifications': 'Save notifications',
  'venue.dashboard.businessLanguage': 'Business language',
  'venue.dashboard.languageHelp': 'Used for the business account and business-authored communication where localization is available.',
  'venue.dashboard.saveLanguage': 'Save language',
  'venue.dashboard.loginEmail': 'Login email',
  'venue.dashboard.requestEmailChange': 'Request email change',
  'venue.dashboard.changePassword': 'Change password',
  'venue.dashboard.currentPassword': 'Current password',
  'venue.dashboard.newPassword': 'New password',
  'venue.dashboard.confirmPassword': 'Confirm new password',
  'venue.dashboard.session': 'Session',
  'venue.dashboard.sessionHelp': 'Sign out when this business account is open on a shared device.',
  'venue.dashboard.signOut': 'Sign out',
  'venue.dashboard.dataClosure': 'Business data & closure',
  'venue.dashboard.dataClosureHelp': 'Export business data or schedule closure. Staff members keep their independent personal accounts.',
  'venue.dashboard.portableExport': 'Portable export',
  'venue.dashboard.portableExportHelp': 'Includes business profile, settings, hosted content, and any preserved legacy personal records.',
  'venue.dashboard.exporting': 'Exporting…',
  'venue.dashboard.downloadExport': 'Download export',
  'venue.dashboard.closeBusiness': 'Close business account',
  'venue.dashboard.closeBusinessHelp': 'Closure has a 7-day grace period and does not delete staff members’ personal accounts.',
  'organizer.setup.pageTitle': 'Organizer setup',
  'organizer.setup.hostTitle': 'Choose how you will host',
  'organizer.setup.hostDescription': 'Use your profile for informal events, or create a group for a recurring community.',
  'organizer.setup.createGroup': 'Create a group',
  'organizer.setup.publishTitle': 'Publish your first event',
  'organizer.setup.publishDescription': 'Add the essentials and publish when the date, access, capacity, pricing, and location are ready.',
  'organizer.setup.createEvent': 'Create event',
  'organizer.setup.inviteTitle': 'Invite participants',
  'organizer.setup.inviteDescription': 'Open the event’s Manage tab and choose people to invite.',
  'organizer.setup.openEvent': 'Open event',
  'organizer.setup.createEventFirst': 'Create event first',
  'organizer.setup.responseTitle': 'Receive the first response',
  'organizer.setup.responseCount':
    'No participants have responded yet. | {count} participant has responded so far. | {count} participants have responded so far.',
  'organizer.setup.responseDescription': 'Responses appear here after an invitee accepts, declines, requests access, or joins a waitlist.',
  'organizer.setup.viewEvent': 'View event',
  'organizer.setup.badge': 'Organizer setup',
  'organizer.setup.title': 'Get your first event moving',
  'organizer.setup.intro': 'This checklist resumes from real activity in your account. It never blocks attendee features.',
  'organizer.setup.progressAria': 'Organizer setup progress',
  'organizer.setup.progress': '{count} of 4 steps complete',
  'organizer.setup.loading': 'Loading organizer progress',
  'organizer.setup.hostMyself': 'Host as myself',
  'organizer.setup.complete': 'Your organizer setup is complete. Keep the momentum going by scheduling the next event.',
  'organizer.setup.createAnother': 'Create another',
  'privacy.eyebrow': 'Vennevent privacy policy',
  'privacy.title': 'Your event data belongs to you. Publish it anywhere.',
  'privacy.intro': 'Vennevent helps people meet in real life without turning their relationships, interests, or whereabouts into an advertising profile.',
  'privacy.effective': 'Effective 25 July 2026 · Pre-launch policy',
  'privacy.plain.heading': 'In plain language',
  'privacy.plain.p1':
    'We collect the information needed to run events, groups, accounts, payments, safety features, and notifications. We do not sell personal data, operate third-party advertising trackers, or build profiles for targeted advertising. Event-related conversations and media are deliberately short-lived.',
  'privacy.plain.p2':
    'You control what you publish, can change profile visibility and notification choices, can download a portable copy of your data, and can schedule account deletion from Settings.',
  'privacy.controller.heading': 'Who is responsible',
  'privacy.controller.beforeLink':
    'Vennevent is currently a pre-launch service. The legal name, postal address, and direct privacy contact of the data controller must be published here before public registration opens. Until then, privacy requests can be exercised through the self-service controls in',
  'privacy.data.heading': 'Information we process',
  'privacy.data.accountTitle': 'Account and profile:',
  'privacy.data.account':
    'email, optional verified phone number, authentication details, display name, username, avatar, bio, language, and privacy preferences.',
  'privacy.data.eventsTitle': 'Events and groups:',
  'privacy.data.events':
    'details you publish, locations, schedules, photos, posts, comments, chat, memberships, invitations, RSVPs, waitlists, tickets, and check-ins.',
  'privacy.data.privateTitle': 'Private choices:',
  'privacy.data.private':
    'bookmarks, saved feeds and people, follows, notification settings, onboarding interests, approximate discovery location, private memories, and age-eligibility information where needed for an age-restricted event.',
  'privacy.data.businessTitle': 'Business and payment information:',
  'privacy.data.business':
    'business applications, staff permissions, booking details, payment status, refund records, and necessary transaction identifiers. Payment providers process payment credentials under their own notices.',
  'privacy.data.technicalTitle': 'Technical and safety information:',
  'privacy.data.technical':
    'authentication sessions, push subscriptions, security and moderation records, operational logs, IP-derived approximate location, browser/device information, error reports, and performance traces.',
  'privacy.data.guests':
    'Guest RSVP does not require an account or email. A guest display name and RSVP state are retained only as needed for that event. A birth date supplied by a guest for age eligibility is checked transiently and is not stored.',
  'privacy.data.contacts':
    'If you choose contact import, your browser shares only the contacts and fields you select. Vennevent checks those email addresses and phone numbers for discoverable accounts, returns public profile information for matches, and discards unmatched contact details without saving them.',
  'privacy.purpose.heading': 'Why we use it',
  'privacy.purpose.purpose': 'Purpose',
  'privacy.purpose.basis': 'Typical legal basis',
  'privacy.purpose.service': 'Provide accounts, discovery, events, groups, RSVPs, invitations, tickets, and requested notifications',
  'privacy.purpose.contract': 'Performing our agreement with you',
  'privacy.purpose.payments': 'Process paid bookings and keep required transaction records',
  'privacy.purpose.contractLegal': 'Contract and legal obligations',
  'privacy.purpose.safety': 'Prevent abuse, secure the service, moderate reports, and maintain reliable operations',
  'privacy.purpose.legitimate': 'Legitimate interests and, where applicable, legal obligations',
  'privacy.purpose.optional': 'Use optional browser location, web push, and optional communications',
  'privacy.purpose.consent': 'Your choice or consent, which you can withdraw',
  'privacy.purpose.noAds': 'We do not use personal data for third-party targeted advertising or sell it to data brokers.',
  'privacy.visibility.heading': 'Visibility and organizer responsibility',
  'privacy.visibility.p1':
    'Public events, public groups, business profiles, and information you deliberately post there may be visible without signing in and may be shared outside Vennevent. Private events, groups, plans, memories, saved people, and restricted profile fields are limited by their applicable access rules.',
  'privacy.visibility.p2':
    'Organizers decide what they publish and must have permission to upload event descriptions, attendee information, and images. Vennevent does not claim ownership of organizer content. You keep your rights and give Vennevent only the permission needed to host, display, distribute, and technically process that content for the service.',
  'privacy.providers.heading': 'Services that receive limited data',
  'privacy.providers.intro': 'Vennevent uses service providers only where needed to operate a feature:',
  'privacy.providers.infrastructure': 'host accounts, records, and uploaded files.',
  'privacy.providers.google': 'receives information when you choose Google sign-in.',
  'privacy.providers.mapbox': 'receives search text or coordinates when map search, reverse geocoding, or location features are used.',
  'privacy.providers.weather': 'receives event coordinates and dates when a near-term event forecast is displayed.',
  'privacy.providers.pixabay': 'receives organizer image-search terms when its optional image search is used.',
  'privacy.providers.sentry': ', when enabled in production, receives application errors, performance traces, IP addresses, and default diagnostic context.',
  'privacy.providers.notificationsTitle': 'Email and browser push providers',
  'privacy.providers.notifications': 'receive the destination and message information needed for notifications you have enabled.',
  'privacy.providers.twilio': 'receives a phone number when you ask to verify it by SMS. Vennevent does not use that number for login or notifications.',
  'privacy.providers.bookingTitle': 'or an external booking provider',
  'privacy.providers.booking': 'receives information when you start a payment or follow an external booking link.',
  'privacy.providers.transfer':
    'Those providers process data under their own terms and may process it outside Norway or the EEA using an applicable transfer mechanism. Following an external link takes you to a separate service with its own privacy practices.',
  'privacy.retention.heading': 'Retention',
  'privacy.retention.chat': 'Event chat is removed 48 hours after the event ends.',
  'privacy.retention.media': 'Event media is removed after 7 days, or after 14 days if the host uses the one-time extension.',
  'privacy.retention.comments': 'Event comments are removed after 30 days.',
  'privacy.retention.events': 'Completed events are removed after 3 calendar months.',
  'privacy.retention.accounts': 'Inactive accounts are removed after 1 year without a successful sign-in.',
  'privacy.retention.audit': 'Privacy-action audit entries contain a hashed user identifier and action category and are removed after 30 days.',
  'privacy.retention.contacts':
    'Contact-matching rate records and SMS verification attempts are removed after 24 hours. Imported address-book details are not retained.',
  'privacy.retention.widgets':
    'Embedded business widgets keep only daily counts by business, surface, and action. They do not store visitor identifiers or raw referring URLs; counts are removed after 90 days and low-volume rows are hidden from business reporting.',
  'privacy.retention.other':
    'Private memories intentionally retained by you remain until you delete the memory or account. Some moderation, transaction, security, or legal records may need a different period. Existing operational backup copies disappear according to the backup retention schedule; requesting deletion does not create a new backup.',
  'privacy.rights.heading': 'Your choices and rights',
  'privacy.rights.intro':
    'Depending on applicable law, you can request access, correction, deletion, restriction, portability, or objection, and withdraw consent at any time.',
  'privacy.rights.settingsBefore': 'Change profile visibility and notification preferences in',
  'privacy.rights.discovery': 'Disable email/phone contact discovery or remove a verified phone number in Settings → People.',
  'privacy.rights.export': 'Download a JSON export from the Privacy control center.',
  'privacy.rights.sessions': 'Revoke all signed-in sessions and remove individual push subscriptions.',
  'privacy.rights.deletion': 'Schedule account deletion with a 7-day cancellation period.',
  'privacy.rights.complaint': 'Complain to the Norwegian Data Protection Authority (Datatilsynet) or another competent supervisory authority.',
  'privacy.rights.account':
    'Deleting the app or closing a browser does not delete an account. Use the deletion control in Settings. Content other people created about their own participation may remain where they have an independent lawful reason to keep it, but it should no longer expose a deleted profile.',
  'privacy.storage.heading': 'Location, cookies, and local storage',
  'privacy.storage.location':
    'Browser location is requested only after you choose a location feature. Onboarding stores rounded coordinates as a discovery preference. The IP-lookup service may estimate a coarse starting area so discovery is useful without GPS.',
  'privacy.storage.browser':
    'Vennevent uses browser storage for authentication, preferences, cached results, recent searches, offline behavior, and short-lived forecast caching. Essential storage is required for the service to work. Vennevent does not use third-party advertising cookies.',
  'privacy.children.heading': 'Children and sensitive information',
  'privacy.children.body':
    'Vennevent is not intended for children below the minimum age required to consent to an online service in their country. Do not publish sensitive personal information in public event, group, post, or chat fields. Age eligibility is kept separately and is not exposed through public profiles.',
  'privacy.security.heading': 'Security and changes',
  'privacy.security.body':
    'We use access controls, signed sessions, server-side authorization, data minimization, and managed deletion jobs. No service can guarantee absolute security. If a breach creates a legal notification obligation, affected people and authorities will be informed as required.',
  'privacy.security.changes':
    'We will update this policy when the service or its providers materially change. The effective date will change, and significant changes will be communicated in the app where appropriate. Previous wording should be retained in the project history.',
  'privacy.footer.help': 'Privacy controls are available without contacting an administrator.',
  'privacy.footer.events': 'Back to events',
  'privacy.footer.controls': 'Privacy controls',
} as const;
